<script lang="ts">
  import SvelteMarkdown from '@humanspeak/svelte-markdown';

  import ScrollShadow from './ScrollShadow.svelte';
  import { dims } from '~/utils/dimensions.svelte';
  import BackButton from './buttons/BackButton.svelte';

  type Props = {
    title: string;
    body: string;
  };
  const props: Props = $props();
</script>

<div class="root" style:margin="{-dims.pad}px">
  <header>
    <BackButton />
    <h1>{props.title}</h1>
    <span></span>
  </header>
  <ScrollShadow>
    <div class="document">
      <SvelteMarkdown source={props.body} />
    </div>
  </ScrollShadow>
</div>

<style lang="scss">
  @use '~/theme/include-media' as *;
  @use '~/theme/themify' as *;
  .root {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  header {
    display: flex;
    align-items: center;
    gap: 1em;
  }
  .document {
    height: 100%;
    margin: 0 auto;
    text-align: start;
    overflow-y: auto;
    overflow-x: hidden;
  }
  header,
  .document {
    width: 100%;
    max-width: 640px;
    @include media('<=tablet') {
      padding: 0 3em;
    }
    @include media('<=540px') {
      padding: 0 1em;
    }
  }
  :global(h1) {
    @include media('<=tablet') {
      font-size: 1.5rem;
    }
  }
  :global(h2) {
    @include media('<=tablet') {
      font-size: 1.25rem;
    }
  }
  :global(li) {
    margin: 0.5em;
  }
  :global(a) {
    @include themify {
      color: themed('link');
    }
  }
</style>
